import { useMemo } from "react";

import { lockScreenIllustration } from "./graphics";
import { useT } from "~/i18n/use-t";

export const ReportLock: React.FC = () => {
  const t = useT();
  const tx = useMemo(
    () => ({
      yourPersonalisedReportIsAlmostReady: t({
        tx: "pageLock.yourPersonalisedReportIsAlmostReady",
      }),
      toUnlockYourTailoredReport: t({
        tx: "pageLock.toUnlockYourTailoredReport",
      }),
      whyIsTheReportLocked: t({ tx: "pageLock.whyIsTheReportLocked" }),
      ourPriorityAtMamaHealth: t({ tx: "pageLock.ourPriorityAtMamaHealth" }),
    }),
    [t],
  );

  return (
    <div className="min-h-dvh flex h-full w-full flex-col items-center justify-start gap-8 overflow-auto px-[15px] py-[60px] ">
      <div className="flex w-full flex-col items-center justify-center text-mama-blue-950">
        <h1 className="mb-4 text-center text-2xl text-[32px] font-bold text-mama-blue-950">
          {tx.yourPersonalisedReportIsAlmostReady}
        </h1>
        <p className="text-center text-[15px]">
          {tx.toUnlockYourTailoredReport}
        </p>
        <img
          src={lockScreenIllustration}
          alt="Placeholder"
          className="mt-4 w-[375px] w-auto max-w-[180px] rounded-lg lg:max-w-[375px]"
        />
      </div>
      <div>
        <div tabIndex={0} className="collapse-arrow collapse">
          <div className="collapse-title text-[16px] font-bold text-mama-blue-950">
            {tx.whyIsTheReportLocked}
          </div>
          <div className="collapse-content">
            <p className="text-[15px] text-mama-blue-950">
              {tx.ourPriorityAtMamaHealth}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
